/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { pushCampaignSchema } from '../listPushCampaignsV1/list-push-campaigns-v1-response';

const pushTokenRowSchema = z.object({
  id: z.number(),
  userId: z.string(),
  token: z.string(),
  platform: z.string(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

const notificationPreferencesSchema = z.object({
  notificationEnabled: z.boolean(),
  timezone: z.string().nullable(),
  reminderTimes: z.array(z.string()),
});

const sendLogRowSchema = z.object({
  id: z.number(),
  userId: z.string(),
  sentDate: z.string(),
  sentTime: z.string(),
  sentAt: z.number(),
});

export const userPushNotificationsV1DataSchema = z.object({
  userId: z.string(),
  notificationPreferences: notificationPreferencesSchema,
  pushTokens: z.array(pushTokenRowSchema),
  sendLog: z.array(sendLogRowSchema),
  messages: z.array(pushCampaignSchema),
});

export type IGetUserPushNotificationsV1Data = z.infer<typeof userPushNotificationsV1DataSchema>;
export type IUserPushTokenRow = z.infer<typeof pushTokenRowSchema>;
export type IUserNotificationPreferences = z.infer<typeof notificationPreferencesSchema>;
export type IUserSendLogRow = z.infer<typeof sendLogRowSchema>;

export const getUserPushNotificationsV1ResponseSchema = createApiResponseSchema(
  userPushNotificationsV1DataSchema,
) as z.ZodSchema<IAPI<IGetUserPushNotificationsV1Data>>;

export type IGetUserPushNotificationsV1Response = IAPI<IGetUserPushNotificationsV1Data>;
